export default "__VITE_ASSET__e8922a0f__"